import { useCMSPageField } from '@/cms/fields'
import { tk, Typography } from '@sunwebgroup/ui-components'
import { isEmpty } from 'ramda'
import { useIntl } from 'react-intl'
import { styled } from 'styled-components'
import { ScoreBar } from './ScoreBar'

const Wrapper = styled.div``

const Heading = styled(Typography)`
  margin-bottom: ${tk('spacing_md')};
`

const ScoreBarTable = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  grid-gap: ${tk('spacing_xs')};
`

export function ScoreBars() {
  const intl = useIntl()
  const scoreByCategory = useCMSPageField('userReviews.scoreByCategory')

  return (
    <>
      {!isEmpty(scoreByCategory) && (
        <Wrapper>
          <Heading $variant="body-lg-bold" as="div">
            {intl.formatMessage({ id: 'reviews_score_bars_heading' })}
          </Heading>
          <ScoreBarTable>
            {scoreByCategory.map(score => (
              <ScoreBar
                key={score.typeId}
                score={score.score}
                label={intl.formatMessage({ id: `reviews_score_bar_label_${score.typeId}` })}
              />
            ))}
          </ScoreBarTable>
        </Wrapper>
      )}
    </>
  )
}
